<template>
  <v-alert
    v-if="filters.dates.to && filters.dates.from !== filters.dates.to"
    color="error"
    type="error"
    dark
    class="mt-2"
  >
    {{ $t("daily_report") }}
  </v-alert>
  <v-card v-else flat>
    <v-row align="center">
      <v-col cols="8" lg="auto">
        <report-meals-select-company></report-meals-select-company>
      </v-col>
      <v-col cols="4" lg="auto">
        <shift-picker v-model="selectedShifts" multiple :disabled="!selectedCompany" />
      </v-col>
    </v-row>
    <v-card-text class="pa-1 pt-4">
      <v-row v-if="loading" justify="center" align="center">
        <v-col cols="12" class="text-center">
          <v-progress-circular
            indeterminate
            color="primary"
            size="48"
          ></v-progress-circular>
        </v-col>
      </v-row>
      <div id="user-daily-orders" v-if="selectedShifts.length > 0 && !loading">
        <template v-for="shift in sortedSelectedShifts">
          <v-row :key="shift" v-if="getUsersForShift(shift).length > 0">
            <v-col cols="12">
              <h3 class="text-center black--text mt-4">
                {{
                  $t(
                    `shift.${
                      shift === 1
                        ? "one"
                        : shift === 2
                        ? "two"
                        : shift === 3
                        ? "three"
                        : "four"
                    }`
                  )
                }}
                (<v-icon>mdi-account</v-icon> {{ getUsersForShift(shift).length }})
              </h3>
            </v-col>
            <v-col
              cols="12"
              md="6"
              lg="4"
              xl="3"
              v-for="(user, i) in getUsersForShift(shift)"
              :key="`${shift}-${user.id}`"
            >
              <v-card class="fill-height ordera-box-shadow user-daily-orders">
                <v-card-title>
                  <v-spacer></v-spacer>
                  <small class="grey--text" v-if="(user.meals || []).length">
                    #{{ user.meals[0].order_id }}&nbsp;
                  </small>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        {{ toLatin(user.name) }} {{ toLatin(user.lastname) }}
                      </span>
                    </template>
                    <span>{{ user.id }}</span>
                  </v-tooltip>
                  <v-spacer></v-spacer>
                </v-card-title>
                <v-card-subtitle></v-card-subtitle>
                <v-list dense>
                  <v-list-item-group v-for="(meal, i) in user.meals" :key="i">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          <strong>{{ meal.total }}x </strong>
                          <span class="subtitle-1">{{ toLatin(meal.name) }}</span>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </template>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import reportService from "@/services/report";
import hasFoodOrders from "@/mixins/report/hasFoodOrders";
import hasPrinting from "@/mixins/hasPrinting";
import ReportMealsSelectCompany from "@/components/report/meals/fields/ReportMealsSelectCompanyField.vue";
import hasReportPrinting from "@/mixins/report/hasReportPrinting";
import hasExcel from "@/mixins/hasExcel";

export default {
  name: "ReportTabGroupMealsTabOrders",
  mixins: [hasFoodOrders, hasPrinting, hasReportPrinting, hasExcel],
  components: {
    ReportMealsSelectCompany,
  },
  data() {
    return {
      users: [],
      narudzbe2: [],
      userOrders: [],
      meals: [],
      loading: false,
      shifts: [1, 2, 3, 4],
      selectedShifts: [1], // Po default tri smene
    };
  },
  methods: {
    getUsersForShift(shiftId) {
      const shiftKey = `shift_${
        shiftId === 1 ? "one" : shiftId === 2 ? "two" : shiftId === 3 ? "three" : "four"
      }`;

      let users = [];

      this.meals
        .filter((meal) => meal[shiftKey])
        .forEach((meal) => {
          const shiftUsers = meal[shiftKey] || [];
          (shiftUsers || []).forEach((user) => {
            // Check if user already exists
            const existingUser = users.find((u) => u.id === user.id);
            if (existingUser) {
              // Add meal to existing user
              existingUser.meals.push({
                id: meal.id,
                name: meal.name,
                order_id: meal.order_id,
                total: user.quantity,
              });
            } else {
              // Add new user with meals array
              users.push({
                ...user,
                meals: [
                  {
                    id: meal.id,
                    name: meal.name,
                    order_id: meal.order_id,
                    total: user.quantity,
                  },
                ],
              });
            }
          });
        });

      // Apply search filter if exists
      if (this.filters.search && this.filters.search.trim() !== "") {
        const searchTerm = this.translate(this.filters.search.toLowerCase().trim());
        users = users.filter((user) => {
          const fullName = this.translate(`${user.name} ${user.lastname}`.toLowerCase());
          if (fullName.includes(searchTerm)) {
            return true;
          }
          if (user.meals && user.meals.length > 0) {
            return user.meals.some((meal) =>
              this.translate(meal.name.toLowerCase()).includes(searchTerm)
            );
          }
          return false;
        });
      }

      return users;
    },
    findUsers() {
      if (!this.selectedCompany) {
        this.users = [];
        return;
      }
      this.loading = true;
      const params = {
        date: this.filters.dates.from,
        date2: this.filters.dates.to,
      };
      reportService
        .getCompanyUserList(this.selectedCompany.id, params)
        .then((response) => {
          this.meals = response.data.meals
            // .filter((meal) => meal.id)
            .filter((meal) => meal.order_id)
            .map((meal) => {
              return {
                id: meal.id,
                name: meal.name,
                order_id: meal.order_id,
                total: meal.total,
                shift_one: meal.users["1-smena"],
                shift_two: meal.users["2-smena"],
                shift_three: meal.users["3-smena"],
                shift_four: meal.users["4-smena"],
              };
            });
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
  computed: {
    sortedSelectedShifts() {
      return this.selectedShifts.slice().sort((a, b) => a - b);
    },
    mealsPerShift() {
      const shifts = [
        {
          id: 1,
          name: this.$t("shift.one"),
          key: "shift_one",
          users: [],
        },
        {
          id: 2,
          name: this.$t("shift.two"),
          key: "shift_two",
          users: [],
        },
        {
          id: 3,
          name: this.$t("shift.three"),
          key: "shift_three",
          users: [],
        },
        {
          id: 4,
          name: this.$t("shift.four"),
          key: "shift_four",
          users: [],
        },
      ];
      shifts.forEach((shift) => {
        this.meals
          .filter((meal) => meal[shift.key])
          .forEach((meal) => {
            const users = meal[shift.key] || [];
            (users || []).forEach((user) => {
              const existingUser = shift.users.find(
                (shiftUser) => shiftUser.id === user.id
              );
              if (existingUser) {
                existingUser.meals.push({
                  id: meal.id,
                  name: meal.name,
                  order_id: meal.order_id,
                  total: user.quantity,
                });
              } else {
                shift.users.push({
                  ...user,
                  meals: [{ ...meal, total: user.quantity }],
                });
              }
            });
          });
      });

      return shifts.filter((shift) => shift.users.length);
    },
    selectedCompany() {
      return this.$store.state.report.selectedMealCompany;
    },
    headers() {
      return [
        { text: this.$t("name"), value: "name" },
        { text: this.$t("last_name"), value: "lastname" },
        ...this.mealCategories.map((category) => ({
          text: this.translate(category),
          value: category,
        })),
      ];
    },
    translatedMealCategories() {
      return this.mealCategories.map((category) => ({
        text: this.translate(category),
        value: category,
      }));
    },
    printItems() {
      return this.userOrders.map((user) => {
        const userData = {
          name: user.name,
          lastname: user.lastname,
          id: user.id,
        };
        this.mealCategories.forEach((category) => {
          userData[category] = user[category].map((meal) => meal.label).join(", ");
        });
        return userData;
      });
    },
    filters() {
      return this.$store.state.report.filters;
    },
    filteredUsersInSelectedShift() {
      if (!this.selectedShifts || this.selectedShifts.length === 0) {
        return [];
      }

      let allUsers = [];

      // Gather users from all selected shifts
      this.selectedShifts.forEach((shiftId) => {
        const shiftKey = `shift_${
          shiftId === 1 ? "one" : shiftId === 2 ? "two" : shiftId === 3 ? "three" : "four"
        }`;
        this.meals
          .filter((meal) => meal[shiftKey])
          .forEach((meal) => {
            const users = meal[shiftKey] || [];
            (users || []).forEach((user) => {
              // Check if user already exists
              const existingUser = allUsers.find((u) => u.id === user.id);
              if (existingUser) {
                // Add meal to existing user
                existingUser.meals.push({
                  id: meal.id,
                  name: meal.name,
                  order_id: meal.order_id,
                  total: user.quantity,
                });
              } else {
                // Add new user with meals array
                allUsers.push({
                  ...user,
                  shift: shiftId,
                  shiftName: this.$t(
                    `shift.${
                      shiftId === 1
                        ? "one"
                        : shiftId === 2
                        ? "two"
                        : shiftId === 3
                        ? "three"
                        : "four"
                    }`
                  ),
                  meals: [
                    {
                      id: meal.id,
                      name: meal.name,
                      order_id: meal.order_id,
                      total: user.quantity,
                    },
                  ],
                });
              }
            });
          });
      });

      if (this.filters.search && this.filters.search.trim() !== "") {
        const searchTerm = this.translate(this.filters.search.toLowerCase().trim());
        allUsers = allUsers.filter((user) => {
          const fullName = this.translate(`${user.name} ${user.lastname}`.toLowerCase());
          if (fullName.includes(searchTerm)) {
            return true;
          }
          if (user.meals && user.meals.length > 0) {
            return user.meals.some((meal) =>
              this.translate(meal.name.toLowerCase()).includes(searchTerm)
            );
          }
          return false;
        });
      }
      return allUsers;
    },
  },
  watch: {
    "filters.dates": {
      handler() {
        this.findUsers();
      },
      deep: true,
    },
    selectedCompany: {
      handler() {
        this.findUsers();
      },
      immediate: true,
    },
    selectedShifts: {
      handler() {
        // Data se automatski filtriraju preko computed property
      },
    },
    isPrinting() {
      if (this.isPrinting) {
        let appendHtml = `<div style='display: flex;flex-wrap: wrap;'>`;
        this.filteredUsersInSelectedShift.forEach((user) => {
          appendHtml += `<div style='flex: 0 0 50%;box-sizing: border-box;padding: 12px;border: 1px solid #ccc;'>
          <h3 style="text-align:center;margin-top: 0"><small style="color: #999">#${user.id}</small> ${user.name} ${user.lastname}</h3>`;
          user.meals.forEach((meal) => {
            appendHtml += `<p>${meal.total}x ${this.toLatin(meal.name)}</p>`;
          });
          appendHtml += `</div>`;
        });
        appendHtml += `</div>`;
        this.printDocument({
          title: [this.$t("report"), this.$t("orders")].join(" "),
          afterTableHtml: appendHtml,
          subtitle: this.subtitle,
          beforeTableHtml: `<h4 style="text-align: center">${
            this.selectedCompany?.company
          }</h4>
          <h5 style="text-align: center">${this.selectedShifts
            .map((shift) =>
              this.$t(
                `shift.${
                  shift === 1
                    ? "one"
                    : shift === 2
                    ? "two"
                    : shift === 3
                    ? "three"
                    : "four"
                }`
              )
            )
            .join(", ")} - ${this.filteredUsersInSelectedShift.length}</h5>`,
        });
      }
    },
    isExcelDownloading() {
      if (this.isExcelDownloading) {
        const orders = this.filteredUsersInSelectedShift.map((order) => {
          order.meals = (order.meals || []).map((meal) => meal.name).join(", ");
          return order;
        });
        this.downloadExcel({
          fileName: [this.$t("report"), this.$t("orders")].join(" ") + ".xlsx",
          sheets: [
            {
              name: this.$t("orders"),
              headers: [...this.headers, { text: this.$t("meals"), value: "meals" }],
              items: orders,
              title: [this.$t("report"), this.$t("orders")].join(" "),
              subtitle: this.subtitle,
              beforeTableHtml: `<h4 style="text-align: center">${this.selectedCompany?.company}</h4>`,
            },
          ],
        });
      }
    },
  },
};
</script>
